import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
export default function ArticleImage(props) {
  const $ = _c(10);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      aspectRatio: "16/9"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = props.altText || "";
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      objectFit: "contain"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== props.url || $[3] !== t1) {
    t3 = <div className="relative" style={t0}><Image src={props.url} fill={true} alt={t1} sizes="100vw" style={t2} /></div>;
    $[2] = props.url;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== props.caption) {
    t4 = props.caption && <div className="article-image__caption mt-2 text-sm text-gray-600 italic">{props.caption}</div>;
    $[5] = props.caption;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <div className="article-image mb-2">{t3}{t4}</div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}